import { all, call, fork, put, takeLatest } from "redux-saga/effects";

import { Creators as Actions, Types } from "ducks/Motoristas";
import { Creators as ActionsGeral } from "ducks/Geral";
import api from "../api/api";
import notify from 'utils/modern_notify';

let motoristasMensagem = "";

const buscarTodosMotoristasRequisicao = async dados =>
    api
        .get(`/api/users/listar/motoristas`, dados)
        .then(motoristasData => motoristasData)
        .catch(error => error);

function* buscarMotoristas({ payload }) {
    const { grupo_emp, base } = payload;

    const empresa = { grupo_emp, base };
    let motoristasData = [];

    motoristasMensagem = "";

    try {
        const response = yield call(buscarTodosMotoristasRequisicao, empresa);

        if (response.ok) {
            motoristasData = response.data.valor.map(motorista => ({
                _id: motorista._id,
                nome: motorista.name ? motorista.name : "",
                cpf: motorista.cpf ? motorista.cpf : "",
                email: motorista.email ? motorista.email : ""
            }));

            yield put(Actions.buscarMotoristasSucesso(motoristasData));
        } else {
            if (Object.prototype.hasOwnProperty.call(response.data, "error")) {
                switch (response.data.error) {
                    default:
                        motoristasMensagem = `Ocorreu um erro: ${response.data.error}`;
                        break;
                }
            } else {
                motoristasMensagem =
                    "Ocorreu um erro interno. Tente novamente!";
            }
            notify(motoristasMensagem)
        }
    } catch (error) {
        // yield put(
        //     ActionsGeral.setMensagem({
        //         mensagem: `Erro ao buscar motoristas: ${error}`,
        //         mostrar: true
        //     })
        // );
        notify(`Erro ao buscar motoristas: ${error}`)
    }
}

export function* buscarDadosTodosMotoristas() {
    yield takeLatest(Types.BUSCAR_MOTORISTAS, buscarMotoristas);
}

export default function* rootSaga() {
    yield all([fork(buscarDadosTodosMotoristas)]);
}
